/**
 * Zwei Scroll-Effekte der Startseite.
 *
 * Beide sind Zugabe, keine Voraussetzung: Ohne dieses Skript steht der
 * Statement-Satz voll lesbar da und das Verfahren zeigt sein erstes Bild.
 * Deshalb schaltet das Skript die Effekte erst selbst frei, statt dass das
 * CSS sie von vornherein annimmt - sonst bliebe bei einem Ladefehler ein
 * grauer, kaum lesbarer Satz stehen.
 *
 * Gesteuert wird beides ueber IntersectionObserver: eine Meldung je Wechsel
 * statt einer je gescrolltem Pixel. Das bleibt auch auf schwachen Geraeten
 * fluessig und kostet keine Scroll-Handler.
 */
(function () {
  'use strict';

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Statement: der Satz hellt auf, sobald er im Blick ist ── */
  function statement() {
    var saetze = document.querySelectorAll('[data-rxk-statement]');
    if (!saetze.length || ruhig) return;

    var beobachter = new IntersectionObserver(
      function (eintraege) {
        for (var i = 0; i < eintraege.length; i++) {
          if (!eintraege[i].isIntersecting) continue;
          eintraege[i].target.classList.add('rxk-statement__satz--hell');
          // Einmalig: Der Satz soll beim Zurueckscrollen nicht wieder ausgrauen.
          beobachter.unobserve(eintraege[i].target);
        }
      },
      { threshold: 0.35, rootMargin: '0px 0px -12% 0px' }
    );

    for (var n = 0; n < saetze.length; n++) {
      saetze[n].setAttribute('data-effekt', 'an');
      beobachter.observe(saetze[n]);
    }
  }

  /* ── Verfahren: das stehende Bild folgt dem sichtbaren Schritt ── */
  function verfahren() {
    var bereiche = document.querySelectorAll('[data-rxk-verfahren]');
    if (!bereiche.length) return;

    // Nur zweispaltig sinnvoll. Darunter steht das Bild ohnehin beim Text,
    // und ein Wechsel waere gar nicht sichtbar.
    if (!window.matchMedia('(min-width: 900px)').matches) return;

    for (var b = 0; b < bereiche.length; b++) {
      (function (bereich) {
        var schritte = bereich.querySelectorAll('[data-rxk-schritt]');
        var bilder = bereich.querySelectorAll('[data-rxk-bild]');
        if (schritte.length < 2 || !bilder.length) return;

        var aktiv = 0;

        function zeige(index) {
          if (index === aktiv) return;
          aktiv = index;
          for (var i = 0; i < bilder.length; i++) {
            bilder[i].classList.toggle('rxk-verf__bild--an', i === index);
          }
        }

        var beobachter = new IntersectionObserver(
          function (eintraege) {
            // Beim Scrollen sind kurz zwei Schritte im Blick - der mit dem
            // groesseren sichtbaren Anteil gewinnt.
            var beste = null;
            for (var i = 0; i < eintraege.length; i++) {
              if (!eintraege[i].isIntersecting) continue;
              if (!beste || eintraege[i].intersectionRatio > beste.intersectionRatio) {
                beste = eintraege[i];
              }
            }
            if (!beste) return;

            var nr = parseInt(beste.target.getAttribute('data-rxk-schritt'), 10);
            if (!isNaN(nr)) zeige(nr);
          },
          { threshold: [0.25, 0.5, 0.75], rootMargin: '-25% 0px -25% 0px' }
        );

        for (var s = 0; s < schritte.length; s++) beobachter.observe(schritte[s]);
      })(bereiche[b]);
    }
  }

  /* ── Auftakt: die Maserung wandert beim Scrollen durch die Schrift ── */
  function maserung() {
    var hero = document.querySelector('[data-rxk-hero-maske]');
    if (!hero || ruhig) return;

    var titel = hero.querySelector('.rxk-hero__titel');
    if (!titel) return;

    var offen = false;

    function setzen() {
      offen = false;
      var kasten = hero.getBoundingClientRect();

      // Nur rechnen, solange der Auftakt im Blick ist.
      if (kasten.bottom < 0 || kasten.top > window.innerHeight) return;

      // 0 am oberen Rand, 1 wenn der Auftakt vollstaendig durchgelaufen ist.
      var lauf = -kasten.top / (kasten.height || 1);
      lauf = Math.max(0, Math.min(1, lauf));

      // 34 % bis 66 %: genug Weg, dass die Bewegung sichtbar ist, aber nicht
      // so viel, dass der Rand des Bildes in die Buchstaben rutscht.
      titel.style.setProperty('--rxk-maser-y', (34 + lauf * 32).toFixed(2) + '%');
    }

    function anstossen() {
      if (offen) return;
      offen = true;
      window.requestAnimationFrame(setzen);
    }

    setzen();
    window.addEventListener('scroll', anstossen, { passive: true });
    window.addEventListener('resize', anstossen, { passive: true });
  }

  /* ── Zahlen laufen hoch, sobald sie im Blick sind ── */
  function zaehler() {
    var ziffern = document.querySelectorAll('[data-rxk-zaehler]');
    if (!ziffern.length || ruhig) return;

    var beobachter = new IntersectionObserver(
      function (eintraege) {
        for (var i = 0; i < eintraege.length; i++) {
          if (!eintraege[i].isIntersecting) continue;
          hochzaehlen(eintraege[i].target);
          beobachter.unobserve(eintraege[i].target);
        }
      },
      { threshold: 0.6 }
    );

    for (var n = 0; n < ziffern.length; n++) beobachter.observe(ziffern[n]);
  }

  function hochzaehlen(el) {
    var roh = el.getAttribute('data-rxk-zaehler') || '';
    // Komma als Dezimaltrennzeichen zulassen, sonst wird "0,1" zu 0.
    var ziel = parseFloat(roh.replace(',', '.'));
    if (isNaN(ziel)) return;

    // Nachkommastellen der Vorlage beibehalten, damit aus 0,1 nicht 0 wird.
    var stellen = (roh.split(/[.,]/)[1] || '').length;
    var komma = roh.indexOf(',') > -1;
    var dauer = 1100;
    var beginn = null;

    function schreiben(wert) {
      var s = wert.toFixed(stellen);
      el.textContent = komma ? s.replace('.', ',') : s;
    }

    schreiben(0);

    function schritt(zeit) {
      if (beginn === null) beginn = zeit;
      var anteil = Math.min(1, (zeit - beginn) / dauer);
      // Schnell anlaufen, sanft ankommen.
      var weich = 1 - Math.pow(1 - anteil, 3);
      schreiben(ziel * weich);
      if (anteil < 1) window.requestAnimationFrame(schritt);
      else schreiben(ziel);
    }

    window.requestAnimationFrame(schritt);
  }

  function start() {
    statement();
    verfahren();
    maserung();
    zaehler();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Im Theme-Editor werden Abschnitte neu geladen, ohne dass die Seite neu
  // aufgebaut wird. Ohne diesen Anschluss saehe Andreas dort einen grauen
  // Satz, der nie aufhellt - und wuerde einen Fehler vermuten, wo keiner ist.
  document.addEventListener('shopify:section:load', start);
})();
